import MultiCityIntResult from './MultiCityIntResult';
import MultiCityDomResult from './MultiCityDomResult';
import ModifySearch from './ModifySearch';

import Header from "../../Components/Header";

export default function MultiCityResult() {
  return (
    <>
     <Header />
      <section className='Results_hotel'>
        <div className='row'>
          <div className='col-md-3 col-lg-3'>
            <div className="box_shadow">
              <div className="modify_btn_srch" data-bs-toggle="modal" data-bs-target="#ModifyResult">Modify Result <i className="fa fa-arrow-right"></i></div>
            </div>
          </div>
          <div className='col-md-9 col-lg-9'>
            <div className="box_shadow_wbg">
              <div class="row ruslt_sort">
                <div class="col-md-12 col-lg-12">
                  <h3 class="destnation">Delhi <i class="fa fa-arrow-right"></i> Mumbai <i class="fa fa-arrow-right"></i> Bangalore <small>Thu , 18 Sep - Fri , 19 Sep | 1 Room, 2 Adult</small></h3></div></div>
              <MultiCityDomResult />
              <MultiCityIntResult />

            </div>
          </div>
        </div>
      </section>

 <div className="modal fade" id="ModifyResult">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Modify Result</h4>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body-update">
              <ModifySearch />
            </div>
          </div>
        </div>
      </div>


    </>
  )

};
